export const GET_SETTINGS = 'CMS/get_settings';
export const GET_SINGLE_SETTING = 'CMS/get_single_setting';
export const UPDATE_SETTING = 'CMS/update_setting';
export const CREATE_SETTING = 'CMS/create_setting';
export const REMOVE_SETTING = 'CMS/remove_setting';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  name: '',
};
